import React from 'react';
import { Monitor, Download, ExternalLink } from 'lucide-react';
import { AppButton } from '../ui';
import './DesktopAppRequired.scss';

const DOWNLOAD_URL = 'https://lmscampus.com/download';

const DesktopAppRequired = () => (
  <div className="desktop-app-required">
    <div className="desktop-app-required__card">
      <div className="desktop-app-required__icon">
        <Monitor size={40} />
      </div>

      <h3 className="desktop-app-required__title">Desktop App Required</h3>

      <p className="desktop-app-required__desc">
        Your institute requires the <strong>LMS Campus Desktop App</strong> for
        secure video playback. All other features (courses, assignments, coding
        practice, etc.) work normally in your browser.
      </p>

      <div className="desktop-app-required__actions">
        <AppButton
          variant="primary"
          size="md"
          onClick={() => window.open(DOWNLOAD_URL, '_blank', 'noopener')}
        >
          <Download size={16} /> Download for Windows
        </AppButton>
        <AppButton
          variant="default"
          size="md"
          onClick={() => window.open(DOWNLOAD_URL, '_blank', 'noopener')}
        >
          <Download size={16} /> Download for Mac
        </AppButton>
      </div>

      <p className="desktop-app-required__hint">
        <ExternalLink size={14} />
        Already installed? Open the desktop app and navigate to this course.
      </p>
    </div>
  </div>
);

export default DesktopAppRequired;
